export default __webpack_public_path__ + "static/media/Ballroll_00285.cef74da3.png";